module.exports = __webpack_public_path__ + "static/media/tooltip_roundabout_slight_right.7c844c27.png";